
import { mapGetters } from 'vuex'
import moment from 'moment'
import { ngtorchRunsVisible, isOverride } from '@/utils/ngtorchRuns.js'

// The ngtorch override one or more runs used, as a chip on a page or, with `icon`, a small icon for a
// list row. Shows nothing when none of them had one, and nothing at all outside dev or to anyone but
// admins and scientists. Reading the overrides is up to the caller (utils/ngtorchRuns.js).
export default {
  props: {
    // One per run, null for a run that used the image's own ngtorch.
    overrides: {
      type: Array,
      default: () => []
    },
    // What ran, when the page shows more than one chip ("Report", "Build").
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'authUser'
    ]),
    visible () {
      return ngtorchRunsVisible(this.authUser)
    },
    entries () {
      const bySha = {}
      const entries = []
      this.overrides.forEach(override => {
        if (!isOverride(override)) return
        if (!bySha[override.sha]) {
          bySha[override.sha] = {
            sha: override.sha,
            ref: override.ref || override.sha.slice(0, 7),
            kind: override.kind,
            reinstall: override.reinstall === true,
            frozenAt: override.frozen_at ? moment(new Date(override.frozen_at)).format('YYYY-MM-DD HH:mm') : '',
            count: 0
          }
          entries.push(bySha[override.sha])
        }
        bySha[override.sha].count++
      })
      return entries
    },
    withoutOverride () {
      return this.overrides.filter(override => !isOverride(override)).length
    },
    chipText () {
      const text = this.entries.length === 1 && this.withoutOverride === 0
        ? `${this.entries[0].ref} @ ${this.entries[0].sha.slice(0, 7)}`
        : this.$t('components.NgtorchRunChip.mixed')
      return this.label ? `${this.label}: ${text}` : text
    }
  }
}
